<div
    [id]="id + '.' + filter.id"
    class="agpr-reachFilter"
>
    <div class="agpr-reachFilter-dropdown">
        <agpr-dropdown
            [id]="'reachFilter_dropdown'"
            [options]="filter.circulationTypeOptions"
            ariaLabel="filterGroup"
            [(ngModel)]="filter.dropdownSelection"
            (ngModelChange)="update()">
        </agpr-dropdown>
    </div>
    <agpr-number-input
        [id]="id + '.' + filter.id + '.min'"
        [label]="'Discover.targeting.filter.audienceReach.minimum'"
        [min]="reachMinimum"
        [max]="value?.range?.max ? value.range.max - 1 : (reachMaximum - 1)"
        [integerOnly]="true"
        [(ngModel)]="value.range.min"
        (ngModelChange)="update()"
    ></agpr-number-input>
    <agpr-number-input
        [id]="id + '.' + filter.id + '.max'"
        [label]="'Discover.targeting.filter.audienceReach.maximum'"
        [min]="value?.range?.min ? value.range.min + 1 : (reachMinimum + 1)"
        [max]="reachMaximum"
        [integerOnly]="true"
        [(ngModel)]="value.range.max"
        (ngModelChange)="update()"
    ></agpr-number-input>
</div>
